module.exports = __webpack_public_path__ + "static/media/works6.fe534810.png";